export default {
    title: 'separator',
    icon: null,
};
